import { areDatesEqual } from '../../utils/common';
import analyticsWrapper from '../analytics/analyticsWrapper';

export default function openTrueCaller(
  jssoObj,
  loginUserCallback,
  onShowCallback,
) {
  analyticsWrapper('ga4', {
    event: 'truecaller_component',
    type: 'truecaller',
    category: 'request_sent',
  });
  analyticsWrapper(
    'gaAndGrx',
    'send',
    'event',
    'truecaller',
    'request_sent',
    'truecaller_component',
  );
  jssoObj.truecallerOneTapLoginV1(
    sucessResponse => {
      console.log('True caller: Successfully logged in', sucessResponse);
      jssoObj.getUserDetails(response => {
        const createdDateStr = response?.data?.createdDate;
        const createdDate = new Date(createdDateStr);
        const currentDate = new Date();
        analyticsWrapper('ga4', {
          event: 'user_login',
          type: 'truecaller',
          category: 'truecaller_one_tap',
          label: areDatesEqual(createdDate, currentDate) ? 'signup' : 'login',
        });
        analyticsWrapper(
          'gaAndGrx',
          'send',
          'event',
          'truecaller',
          'user_login',
          'truecaller_one_tap',
        );
      });
      if (loginUserCallback && typeof loginUserCallback === 'function') {
        loginUserCallback();
      }
    },
    errorResponse => {
      if (errorResponse?.failedType) {
        const map = {
          APP_NOT_INSTALLED: 'not_installed',
          TIMEOUT: 'timeout',
        };
        if (errorResponse?.failedType === 'APP_NOT_INSTALLED') {
          analyticsWrapper('ga4', {
            event: 'truecaller_component',
            category: 'app_not_installed',
            type: 'truecaller',
          });
          analyticsWrapper(
            'gaAndGrx',
            'send',
            'event',
            'truecaller',
            'app_not_installed',
            'truecaller_component',
          );
        } else if (errorResponse?.failedType === 'TIMEOUT') {
          analyticsWrapper('ga4', {
            event: 'truecaller_component',
            category: 'component_timeout',
            type: 'truecaller',
          });
          analyticsWrapper(
            'gaAndGrx',
            'send',
            'event',
            'truecaller',
            'component_timeout',
            'truecaller_component',
          );
        }
        if (map[errorResponse?.failedType] === map.APP_NOT_INSTALLED) {
          if (onShowCallback && typeof onShowCallback === 'function') {
            onShowCallback(false);
          }
        }
      }
    },
    popUpCallback => {
      if (popUpCallback?.type) {
        if (popUpCallback?.type === 'OPEN') {
          analyticsWrapper('ga4', {
            event: 'truecaller_component',
            type: 'truecaller',
            category: 'component_shown',
          });
          analyticsWrapper(
            'gaAndGrx',
            'send',
            'event',
            'truecaller',
            'component_shown',
            'truecaller_component',
          );
          if (onShowCallback && typeof onShowCallback === 'function') {
            onShowCallback(true);
          }
        } else if (popUpCallback?.type === 'SKIP') {
          analyticsWrapper('ga4', {
            event: 'truecaller_component',
            type: 'truecaller',
            category: 'truecaller_skip_click',
          });
          analyticsWrapper(
            'gaAndGrx',
            'send',
            'event',
            'truecaller',
            'truecaller_component',
            'truecaller_skip_click',
          );
        }
      }
    },
  );
}
